<template>
  <v-scale-screen width="1920" height="1080" :fullScreen="true">
    <div class="energy-cockpit-shell" :class="`domain-${domain}`">
      <header class="energy-shell-header">
        <ul class="shell-left">
          <li class="shell-home" @click="$router.push('/home')">
            <img src="../../../assets/images/electricity/home-page.png" alt="" />
            <span>首页</span>
          </li>
          <li>
            <img src="../../../assets/images/electricity/date.png" alt="" />
            <span>{{ nowText }}</span>
          </li>
        </ul>
        <div class="shell-title">
          <img src="../../../assets/images/electricity/logo.png" alt="" />
          <span>{{ title }}</span>
        </div>
        <ul class="shell-right">
          <li><img src="../../../assets/images/cockpit/address.png" alt="" /><span>{{ location }}</span></li>
          <li><img src="../../../assets/images/cockpit/avatar.png" alt="" /><span>调度值班员</span></li>
        </ul>
      </header>
      <EnergyDomainNav :active-domain="domain" />
      <slot />
      <div v-if="demo" class="demo-data-flag">演示数据</div>
    </div>
  </v-scale-screen>
</template>

<script>
import EnergyDomainNav from "./EnergyDomainNav.vue";

export default {
  name: "EnergyCockpitShell",
  components: { EnergyDomainNav },
  props: {
    domain: { type: String, required: true },
    title: { type: String, required: true },
    location: { type: String, default: "京津冀示范场站" },
    demo: { type: Boolean, default: true },
  },
  data() { return { nowText: "", timer: null }; },
  mounted() {
    this.updateNow();
    this.timer = setInterval(this.updateNow, 1000);
  },
  beforeDestroy() { clearInterval(this.timer); },
  methods: {
    updateNow() {
      const date = new Date();
      const pad = (value) => String(value).padStart(2, "0");
      const week = ["日", "一", "二", "三", "四", "五", "六"][date.getDay()];
      this.nowText = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} 星期${week} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<style>
.energy-cockpit-shell {
  position: relative;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  color: #dbeeff;
  background:
    radial-gradient(circle at 50% 44%, rgba(19, 87, 177, .2), transparent 48%),
    url("../../../assets/images/electricity/background.jpg") no-repeat center / cover;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.energy-shell-header {
  position: relative;
  z-index: 70;
  width: 1920px;
  height: 112px;
  padding: 15px 29px 0;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: url("../../../assets/images/electricity/header-background.png") no-repeat center / cover;
}
.shell-left,
.shell-right { width: 570px; height: 42px; margin: 0; padding: 0; display: flex; align-items: center; gap: 28px; list-style: none; }
.shell-right { justify-content: flex-end; }
.shell-left li,
.shell-right li { display: flex; align-items: center; gap: 7px; color: #a8cef3; font-size: 13px; }
.shell-left img,
.shell-right img { width: 17px; height: 17px; object-fit: contain; }
.shell-home { cursor: pointer; }
.shell-title { position: absolute; top: 13px; left: 50%; width: 650px; height: 42px; display: flex; align-items: center; justify-content: center; transform: translateX(-50%); }
.shell-title img { width: 33px; margin-right: 12px; }
.shell-title span { color: #f0f8ff; font-size: 25px; font-weight: 700; letter-spacing: 2px; text-shadow: 0 0 14px rgba(63, 168, 255, .46); }
.demo-data-flag { position: absolute; z-index: 90; right: 20px; bottom: 13px; padding: 4px 10px; color: #5681a8; border: 1px solid rgba(83, 139, 191, .22); background: rgba(4, 22, 55, .6); font-size: 9px; letter-spacing: 1px; }
.energy-panel {
  position: relative;
  box-sizing: border-box;
  background: linear-gradient(135deg, rgba(5, 27, 70, .91), rgba(3, 17, 48, .78));
  border: 1px solid rgba(53, 135, 211, .27);
  box-shadow: inset 0 0 32px rgba(27, 110, 196, .09);
}
.energy-panel::before,
.energy-panel::after { content: ""; position: absolute; top: -1px; width: 18px; height: 8px; border-top: 2px solid #37dce3; pointer-events: none; }
.energy-panel::before { left: -1px; border-left: 2px solid #37dce3; }
.energy-panel::after { right: -1px; border-right: 2px solid #37dce3; }
.energy-panel-title { height: 34px; padding: 10px 14px 0; box-sizing: border-box; display: flex; align-items: flex-start; border-bottom: 1px solid rgba(58, 131, 204, .16); }
.energy-panel-title i { width: 7px; height: 7px; margin: 2px 8px 0 0; border: 1px solid #41e7dc; transform: rotate(45deg); box-shadow: 0 0 8px rgba(65, 231, 220, .5); }
.energy-panel-title strong { font-size: 12px; }
.energy-panel-title em { margin-left: auto; color: #4e789e; font-size: 8px; font-style: normal; letter-spacing: 1px; }
.energy-chart { width: 100%; height: calc(100% - 34px); }
.status-normal { color: #40ecc2 !important; }
.status-warning { color: #f6cd29 !important; }
.status-danger { color: #ff635f !important; }
</style>
